import { useQuery } from '@tanstack/react-query';
import { proposalProjectApiConnect } from '../lib/api/proposalProjectApi.connect';
/**
 * Fetch LCATs (Labor Categories) for a proposal project
 */ export function useLCATs(projectId) {
    return useQuery({
        queryKey: [
            'lcats',
            projectId
        ],
        queryFn: ()=>proposalProjectApiConnect.getLCATs(projectId),
        staleTime: 60000,
        enabled: !!projectId,
        retry: 1,
        placeholderData: {
            laborCategories: [],
            stats: {
                totalCategories: 0,
                averageRate: 0,
                minRate: 0,
                maxRate: 0
            }
        }
    });
}
